import React, {useEffect, useMemo, useState, useRef} from "react";
import Skeleton from "@mui/material/Skeleton";

const ADSImage = ({ path, file = null, skeletonWidth = 100, skeletonHeight = 100, ...props }) => {
  const [imageData, setImageData] = useState(null);
  const [loading, setLoading] = useState(false);
  // Use a ref to track the current objectUrl without triggering re-renders
  const objectUrlRef = useRef(null);

  const url = useMemo(() => window.localStorage.getItem("BaseURL") + path, [path]);

  useEffect(() => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImageData(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  }, [file, path]);

  useEffect(() => {
    const fetchImage = async () => {
      setLoading(true)

      try {
        const response = await fetch(url, {
          headers: {
            'Authorization': "Bearer " + window.localStorage.getItem("Token")
          }
        });

        if (response.ok) {
          const blob = await response.blob();
          // Clean up previous objectUrl if it exists
          if (objectUrlRef.current) {
            URL.revokeObjectURL(objectUrlRef.current);
          }
          // Create new objectUrl and store it in the ref
          const newObjectUrl = URL.createObjectURL(blob);
          objectUrlRef.current = newObjectUrl;
          setImageData(newObjectUrl);
        }
      } catch (error) {
        console.error("Failed to fetch image:", error);
      } finally {
        setLoading(false);
      }

    };

    if (path) {
      fetchImage();
    }

    // Cleanup function
    return () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    };
  }, [path, url]); // url is the only dependency

  return !loading && imageData ? <img src={imageData} alt="auth-image" {...props} /> : <Skeleton variant="rectangular" width={skeletonWidth} height={skeletonHeight} style={{ borderRadius: '15px' }} {...props} />;
};

export default ADSImage;
